
/*
 * spurtcommerce
 * version 4.3
 * http://api.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  Inject,
  SimpleChanges,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../../core/service/config.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ListsService } from 'src/core/lists/lists.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-spurt-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.scss']
})
export class ProductFilterComponent implements OnInit, OnDestroy {
  // price filter
  public priceFrom: any = 0;
  public priceTo: any = 0;


  // filter used new
  public conditions = [
    { option: 'All', value: '' },
    { option: 'New', value: 1 },
    { option: 'Used', value: 2 }
  ];
  // product list
  private keyword: any = '';
  public condition = 0;
  public rupees: any;
  private oneTimeAssignValue = 1;
  @Input() isClickedData: any;
  @Input() brandId: any;
  @Input() category: any;
  @Output() progressEmit = new EventEmitter<string>();
  @Output() attributeData: EventEmitter<any> = new EventEmitter();
  // radio form variable
  public radioForm: FormGroup;
  public radio: FormControl;
  // image
  public imagePath: string;
  private subscriptions: Array<Subscription> = [];
  public categorySlug: any;
  public variant: any = [];
  public attribute: any = [];
  public selectedVariant: any = {};
  public brandIdarray = [];
  public Specs = [];
  // Fiter data
  Filterkeys = [];
  ValueData = [];
  categoryData: any;
  brands: any;
  subCategory: any[] = [];
  
  public select: any;
  selvalue: any;
  isChecked: any;

  constructor(
    private router: Router,
    public listSandbox: ListsSandbox,
    private configService: ConfigService,
    private fb: FormBuilder,
    public route: ActivatedRoute,
    private listsService: ListsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.route.params.subscribe(data => {
      if (data.id) {
        this.categorySlug = data.id;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.Specs.length = 0;
    if (this.category && this.category !== '' && this.category !== 'All') {
      this.getCategory(this.category);
      this.categoryFilter(this.category);
    } else {
      this.getCategories();
    }
  }
  // Initially calls getCategories,getBrands function.
  ngOnInit() {
    console.log("category@@@@@",this.category)
    console.log('isClicked',this.isClickedData)
    this.brandsList();
    this.Specs.length = 0;
    // console.log('checking category', this.category);
    // console.log('checking Manufacturer', this.brandId);
    if (this.category) {
      this.categoryFilter(this.category);
      console.log("idddddddddd==>", this.category)
    }
    if (isPlatformBrowser(this.platformId)) {
      this.rupees = JSON.parse(localStorage.getItem('currency')).symbol ? JSON.parse(localStorage.getItem('currency')).symbol : '';
    }
    this.imagePath = this.configService.getImageUrl();
    // this.getBrands();

    /**               INITIALLY SET VALUE  (FROM PRICE) AND  (TO PRICE)
     * subscribe listSandbox maxProductPrice$  to get  maximum product price and as well as set default minimum price.
     * priceTo gets value from listSandbox.maxProductPrice$ and  convert string to number format
     * priceFrom gets value from listSandbox.maxProductPrice$ and  convert string to number format
     * **/
    this.subscriptions.push(
      this.listSandbox.maxProductPrice$.subscribe(maximumPrice => {
        if (maximumPrice && this.oneTimeAssignValue === 1) {
          const tempPriceTo = JSON.parse(maximumPrice);
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('priceTo', '10000');
            this.priceTo = localStorage.getItem('priceTo');
          }
          const initialToPrice = '0';
          this.priceFrom = JSON.parse(initialToPrice);
          this.oneTimeAssignValue++;
        }
      })
    );
  }

  // get All brands
  brandsList() {
    const params = {
      storename: environment.storename,
      selected: environment.settingsId
    };
    this.listSandbox.getManufacturerList(params);
  }
  // Category Filter
  categoryFilter(id: any) {
    console.log("testing id====>",  id)
    this.Filterkeys = []
    console.log('---------cate ID',id)
    const params = {
      categorySlug: id,
      settingsId: environment.settingsId
    };
    this.listsService.getSubCategoryList_new(params)
      .subscribe((res: any) => {
        console.log("params==========================================================3");
          console.log(params);
        console.log('re 21',res)
        const specs = res.specs;
        this.categoryData = res?.categoryDataId?.children1;
        console.log("cate4gory lits",this.categoryData)
        if(res?.categoryDataId?.children1.length === 0){
          this.categoryData = res?.categoryDataId?.children; 
        }
        if(id === '220-Volt-Appliances-(Overseas-use-only)'){
          // console.log('--res cat')
          this.categoryData.map((data:any)=>{

            this.subCategoryFilter(data.categorySlug)
          })
        }
        const getspecs = res.GetSepec;
        if (getspecs.length !== 0) {
          for (let i = 0; i < getspecs.length; i++) {
            // console.log('SpecTypeId==>',res.data.GetSepec[i].SpecTypeId)
            for (let j = 0; j < specs.length; j++) {
              if (specs[j].spec_type_id === getspecs[i].SpecTypeId) {
                this.Filterkeys.push(specs[j].name);
                console.log("testing",this.Filterkeys)
              }
            }
          }
          this.Filterkeys = [...new Set(this.Filterkeys)];
          this.ValueData = specs;     
        } else {
          this.Filterkeys = [];
          this.ValueData = [];
        }

      });
      console.log('-----data111111111111111111111111111111111111',this.Filterkeys)    
      console.log('-----data',this.ValueData)   
    
  }


  refreshComponent(): void {
    // Use Angular Router to navigate to the same route
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }

  subCategoryFilter(i) {
    if(i === '220-volt-major-applainces'){
      this.categoryData = []
      const params = {
        categorySlug: i,
        settingsId: environment.settingsId
      };
      this.listsService.getSubCategoryList(params)
        .subscribe((res: any) => {
          this.subCategory = res?.categoryDataId?.children1.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive comparison
        const nameB = b.name.toUpperCase();
        
        if (nameA < nameB) {
          return -1; // If nameA should appear before nameB
        }
        if (nameA > nameB) {
          return 1; // If nameA should appear after nameB
        }
        return 0; // If nameA and nameB are equivalent
      });
          
        });

      //  this.subCategory =  this.rawSubCategory
       
    }  
    
  }

  // calls listSandbox getManufacturerList for getting brand list
  // public getBrands() {
  //   const params: any = {};
  //   params.limit = '';
  //   params.offset = 0;
  //   params.keyword = '';
  //   this.listSandbox.getManufacturerList(params);
  // }
  // calls listSandbox getCategoryList with default param values
  public getCategories() {
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.sortOrder = '';
    this.listSandbox.getCategoryList(params);
  }
  getCategory(id) {
    const params: any = {};
    params.categorySlug = id;
    params.settingsId = environment.settingsId;
    this.listSandbox.getCategory(params);
  }

  // calls getProducts for filter
  public onChangeCategory(params) {
   

    console.log('params==-->',params)
    this.category = params.id;
    this.categorySlug = params.slug;
    this.getProducts();


  // this.categoryFilter(this.category);
  this.ngOnInit()
   
  }
  /**
   *  selecting brand in the brand list.
   *  Then calls getProducts to refresh the product list,
   *  set ,get,remove local storage for brandId.
   *  remove brandSelectionKey local storage.
   *  **/
  public selectBrand(event, brandId) {
    // console.log('brand is checked or not', event);
    // if (brandId === +this.brandId) {
    //   this.brandId = '';
    // } else {
    //   this.brandId = brandId;
    // }

    if (event.checked) {
      this.brandIdarray.push(brandId);
    } else {
      this.brandIdarray = this.brandIdarray.filter(data => {
        if (data === brandId) {
          return false;
        } else {
          return true;
        }
      });
    }

    this.getProducts();
  }

  /** calls getProducts event changed,
   * @param id from condition event **/
  changeCondition(event, id) {
    this.condition = id;
    this.getProducts();
  }

  /** set local storage value,
   *  after the price value changed based on the slider.
   *  @param event from priceFrom slider
   * **/
  priceFromValue(event: any) {
    this.priceFrom = event.value;
      console.log("tovalue",this.priceFrom)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('fromPrice');
      localStorage.setItem('fromPrice', event.value);
      const num = localStorage.getItem('fromPrice');
      this.priceFrom = num;
    }
    this.selectPrice()
  }

  /** set local storage value,
   *  after the price value changed based on the slider.
   *  @param event from priceTo slider
   * **/
  priceToValue(event) {
    this.priceTo = event.value;
    console.log("tovalue",this.priceTo)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('priceTo');
      const objStr = JSON.stringify(this.priceTo);
      localStorage.setItem('priceTo', this.priceTo);
      this.priceTo = localStorage.getItem('priceTo');
    }
    this.selectPrice()
  }

  /**calls getProducts for price filter
   * **/
  selectPrice() {
    console.log("%%%%",event)
    this.getProducts();
  }

  /**
   * calls listSandbox getProductList.Then calls listSandbox getProductCount
   *And also emits the param to product list for correct pagination.
   * */
    getProducts() {
    const params: any = {};
    params.refresh = false;
    if (this.brandIdarray.length > 0) {
      const brands = this.brandIdarray.toString();
      params.manufacturerId = brands;
    } else {
      params.manufacturerId = '';
    }
    /**  during removing local storage it assigns null string
     * this condition will handle that.**/
    params.keyword = this.keyword;
    params.Specs = this.Specs;
    localStorage.setItem('specs', this.Specs.toString());

    if (this.category === 'null' || this.category == null) {
      this.category = '';
      params.categoryslug = this.categorySlug;
    } else if (this.categorySlug === undefined) {
      params.categoryslug = '';
    } else {
      params.categoryslug = this.categorySlug;
    }
    if (this.priceFrom == null) {
      this.priceFrom = 1;
      params.priceFrom = this.priceFrom;
    } else {
      params.priceFrom = this.priceFrom;
    }
    if (isPlatformBrowser(this.platformId)) {
      if (!localStorage.getItem('priceTo')) {
        this.priceTo = '';
        params.priceTo = this.priceTo;
      } else {
        params.priceTo = this.priceTo;
      }
    }
    params.condition = this.condition;
    this.progressEmit.emit(params);
    console.log("emited values",this.progressEmit.emit(params))
  }
  ngOnDestroy() {
    this.subscriptions.forEach(each => {
      each.unsubscribe();
    });
  }
  changed = (evt) => {    
    this.isChecked = evt.target.checked;
    }

  // Specification
  selectSpecs(Value, event) {
    this.isChecked = event.target.checked;
    // this.Specs.length = 0
    console.log('event==>',this.isChecked )
    const value = this.Specs.indexOf(Value);
    if (value === -1) {
      this.Specs.push(Value);
      this.getProducts();
    } else {
      this.Specs.splice(value, 1);
      this.getProducts();
    }

    // this. refreshComponent()

  }

  filter(){
    console.log("spec",this.selvalue)

    this.priceFrom = 0;
    this.priceTo = 10000;
    console.log("$$$$%$",this.Specs )
    this.Specs
    this.select = ''
    this.selvalue = ''
    
    this.getProducts();
  
  }

  setAll(){
    
  }

}